<nav class="aes-system-header navbar navbar-light bg-white">
  <div class="container-fluid align-items-center">
    <a class="navbar-brand" routerLink="/Home" aria-label="Ahmed Elshahat System">
      <img src="/assets/logo-01.png" class="card-img" alt="Logo" />
    </a>

    @if (tokenExists) {
<div class="header-actions">
  <button
    type="button"
    class="quick-nav-btn"
    routerLink="/companies"
    aria-label="الشركات"
    title="الشركات"
  >
    <i class="fa-solid fa-building"></i>
  </button>

  <button
    type="button"
    class="quick-nav-btn"
    routerLink="/doctors"
    aria-label="الأطباء"
    title="الأطباء"
  >
    <i class="fa-solid fa-user-doctor"></i>
  </button>

  <button
    type="button"
    class="quick-nav-btn"
    routerLink="/alljobz"
    aria-label="الكوادر"
    title="الكوادر"
  >
    <i class="fa-solid fa-users"></i>
  </button>

  <button
    type="button"
    class="chat-alert-btn"
    [class.has-alert]="hasChatNotification"
    (click)="openChats()"
    aria-label="إشعارات المحادثات"
  >
    <i class="fa-solid fa-comments"></i>

    @if (unreadChatCount > 0) {
      <span>{{ unreadChatCount > 99 ? '99+' : unreadChatCount }}</span>
    }
  </button>

  <button
    type="button"
    class="chat-alert-btn"
    [class.has-alert]="hasApplicationNotification"
    (click)="openApplications()"
    aria-label="إشعارات التقديمات"
  >
    <i class="fa-solid fa-file-signature"></i>

    @if (unreadApplicationCount > 0) {
      <span>{{ unreadApplicationCount > 99 ? '99+' : unreadApplicationCount }}</span>
    }
  </button>

  <button
    class="navbar-toggler menu-toggler"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#sideMenu"
    aria-controls="sideMenu"
    aria-label="فتح القائمة"
  >
    <i class="fa-solid fa-bars"></i>
  </button>
</div>
    }

    <div
      class="offcanvas offcanvas-end side-menu"
      tabindex="-1"
      id="sideMenu"
      aria-labelledby="sideMenuLabel"
    >
      <div class="offcanvas-header">
        <div class="side-brand">
          <img src="/assets/logo-01.png" class="side-logo" alt="Logo" />

          <div>
            <strong id="sideMenuLabel">لوحة أحمد الشحات</strong>
            <small>إدارة النظام والموقع</small>
          </div>
        </div>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="إغلاق"
        ></button>
      </div>

      <div class="offcanvas-body">
        <ul class="navbar-nav side-nav">
          @if (isfinancialEmployee) {
            <li
              class="nav-item"
              routerLink="/myclients"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-address-book menu-icon"></i>
              <span class="nav-link">
                {{ "myclients" | translate }}
              </span>
            </li>

            <li
              class="nav-item"
              routerLink="/dailyexpenses"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-money-bill-trend-up menu-icon"></i>
              <span class="nav-link">
                {{ "financial" | translate }}
              </span>
            </li>
          } @else {
            @if (tokenExists) {
              <li
                class="nav-item"
                routerLink="/companies"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-building menu-icon"></i>
                <span class="nav-link">الشركات</span>
              </li>

              <li
                class="nav-item"
                routerLink="/doctors"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-user-doctor menu-icon"></i>
                <span class="nav-link">الأطباء</span>
              </li>

              <li
                class="nav-item"
                routerLink="/alljobz"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-users menu-icon"></i>
                <span class="nav-link">الكوادر</span>
              </li>

              <li
                class="nav-item"
                routerLink="/dataflow"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-file-shield menu-icon"></i>
                <span class="nav-link">داتافلو</span>
              </li>

              <li
                class="nav-item"
                routerLink="/flyclients"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-plane-departure menu-icon"></i>
                <span class="nav-link">الطيران</span>
              </li>

              <li
                class="nav-item"
                routerLink="/reviews"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-star-half-stroke menu-icon"></i>
                <span class="nav-link">التقييمات</span>
              </li>

              <li
                class="nav-item"
                routerLink="/createblog"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-pen-to-square menu-icon"></i>
                <span class="nav-link">إنشاء مدونة</span>
              </li>

              <li
                class="nav-item chat-menu-item"
                routerLink="/allchats"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-comments menu-icon"></i>
                <span class="nav-link">المحادثات</span>

                @if (unreadChatCount > 0) {
                  <span class="menu-badge">
                    {{ unreadChatCount > 99 ? '99+' : unreadChatCount }}
                  </span>
                }
              </li>

              <li
                class="nav-item"
                routerLink="/allblogs"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-newspaper menu-icon"></i>
                <span class="nav-link">المدونات</span>
              </li>

              <li class="nav-item menu-dropdown" routerLinkActive="active-dropdown">
                <button
                  class="dropdown-toggle-btn"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#jobsMenuCollapse"
                  aria-expanded="false"
                  aria-controls="jobsMenuCollapse"
                >
                  <span class="menu-label">
                    <i class="fa-solid fa-briefcase menu-icon"></i>
                    الوظائف
                  </span>

                  <i class="fa-solid fa-chevron-down dropdown-arrow"></i>
                </button>

                <div class="collapse submenu-collapse" id="jobsMenuCollapse">
                  <div
                    class="submenu-link"
                    routerLink="/alljobs"
                    routerLinkActive="active"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="fa-solid fa-list-check menu-icon small-icon"></i>
                    إدارة الوظائف
                  </div>

                  <div
                    class="submenu-link"
                    routerLink="/add-skill"
                    routerLinkActive="active"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="fa-solid fa-wand-magic-sparkles menu-icon small-icon"></i>
                    المهارات
                  </div>

                  <div
                    class="submenu-link"
                    routerLink="/apply"
                    routerLinkActive="active"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="fa-solid fa-file-signature menu-icon small-icon"></i>
                    التقديمات
                  </div>

                  <div
                    class="submenu-link"
                    routerLink="/add-country"
                    routerLinkActive="active"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="fa-solid fa-earth-africa menu-icon small-icon"></i>
                    الدول والمدن
                  </div>
                </div>
              </li>

              <li
                class="nav-item"
                routerLink="/complex"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-boxes-stacked menu-icon"></i>
                <span class="nav-link">الطلبات</span>
              </li>

              <li
                class="nav-item"
                routerLink="/Slider"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-sliders menu-icon"></i>
                <span class="nav-link">إدارة الموقع</span>
              </li>

              <li
                class="nav-item"
                routerLink="/myclients"
                routerLinkActive="active"
                data-bs-dismiss="offcanvas"
              >
                <i class="fa-solid fa-address-book menu-icon"></i>
                <span class="nav-link">
                  {{ "myclients" | translate }}
                </span>
              </li>

              @if (showAllUsers) {
                <li
                  class="nav-item"
                  routerLink="/dailyexpenses"
                  routerLinkActive="active"
                  data-bs-dismiss="offcanvas"
                >
                  <i class="fa-solid fa-money-bill-trend-up menu-icon"></i>
                  <span class="nav-link">
                    {{ "financial" | translate }}
                  </span>
                </li>

                <li
                  class="nav-item"
                  routerLink="/allemployees"
                  routerLinkActive="active"
                  data-bs-dismiss="offcanvas"
                >
                  <i class="fa-solid fa-user-tie menu-icon"></i>
                  <span class="nav-link">
                    {{ "employees" | translate }}
                  </span>
                </li>
              }
            }
          }

          @if (isAdmin) {
            <li
              class="nav-item"
              routerLink="/allusers"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-user-gear menu-icon"></i>
              <span class="nav-link">
                {{ "Users" | translate }}
              </span>
            </li>
          }

          @if (tokenExists) {
            <li
              class="nav-item"
              routerLink="/Profile"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-user menu-icon"></i>
              <span class="nav-link">
                {{ "Profile" | translate }}
              </span>
            </li>

            <li
              class="nav-item"
              routerLink="/fingerprint"
              routerLinkActive="active"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-fingerprint menu-icon"></i>
              <span class="nav-link">
                {{ "fingerprint" | translate }}
              </span>
            </li>
          }

            <li
              class="nav-item"
            role="button"
            tabindex="0"
            (click)="toggleLanguage()"
            (keydown.enter)="toggleLanguage()"
            data-bs-dismiss="offcanvas"
          >
            <i class="fa-solid fa-language menu-icon"></i>
            <span class="nav-link">
              {{ "Change to Arabic" | translate }}
            </span>
          </li>

          @if (tokenExists) {
            <li
              class="nav-item logout-item"
              role="button"
              tabindex="0"
              (click)="logout()"
              (keydown.enter)="logout()"
              data-bs-dismiss="offcanvas"
            >
              <i class="fa-solid fa-right-from-bracket menu-icon"></i>
              <span class="nav-link">
                {{ "Log out" | translate }}
              </span>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</nav>
